"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateToCallbacks = void 0;
const context_1 = require("../../oas/context");
const utils_1 = require("../../utils");
const operation_1 = require("../operation");
const translateToCallbacks = function (callbacks) {
    const callbackEntries = (0, utils_1.entries)(callbacks);
    if (!callbackEntries.length)
        return;
    return callbackEntries.reduce((results, [callbackName, path2Methods]) => {
        for (const [path, method2Op] of (0, utils_1.entries)(path2Methods)) {
            for (const [method, op] of (0, utils_1.entries)(method2Op)) {
                const document = {
                    openapi: '3',
                    info: { title: '', version: '1' },
                    paths: { [path]: { [method]: op } },
                };
                const ctx = (0, context_1.createContext)(document);
                ctx.context = 'callback';
                Object.assign(ctx.ids, this.ids);
                ctx.ids.operation = this.generateId.httpCallbackOperation({ parentId: this.ids.service, method, path });
                results.push({
                    ...(0, operation_1.transformOas3Operation)({
                        document,
                        method,
                        path,
                        ctx,
                    }),
                    callbackName,
                });
            }
        }
        return results;
    }, []);
};
exports.translateToCallbacks = translateToCallbacks;
//# sourceMappingURL=callbacks.js.map